import ContentComponent from './Content';
import WrapperComponent from './Wrapper';

export const Content = ContentComponent;
export const Wrapper = WrapperComponent;
